import { IdBuilding } from "../constants/IdBuilding";
export var selectBaseInfo = function (state) { return state.baseInfo; };
export var selectNumberOfAcres = function (state) {
    var buildings = state.baseInfo.buildings;
    if (buildings !== undefined) {
        var filteredBuildings = buildings.filter(function (building) { return building.typeId === IdBuilding.Acre; });
        return filteredBuildings.length;
    }
    return 0;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectBaseInfo.ts
// module id = 2240
// module chunks = 3